// import { useState, useEffect } from "react";
// import LoginForm from "./LoginForm";
// import RegisterForm from "./RegisterForm";
// import { XMarkIcon } from "@heroicons/react/24/outline";
// import { useLocation } from "react-router-dom";

// // Helper to extract ?lid=... from the URL
// function useAffiliateId() {
//   const { search } = useLocation();
//   const params = new URLSearchParams(search);
//   return params.get("lid") || "";
// }

// const AuthModal = ({ isOpen, onClose, initialMode = "login" }) => {
//   const [mode, setMode] = useState(initialMode); // 'login' or 'register'
//   const affiliateId = useAffiliateId();

//   useEffect(() => {
//     if (isOpen) setMode(initialMode);
//   }, [isOpen, initialMode]);

//   if (!isOpen) return null;

//   return (
//     <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-60">
//       <div className="bg-slate-900 text-white w-full max-w-4xl mx-4 md:mx-auto rounded-2xl overflow-hidden shadow-2xl flex">
//         {/* Left Side */}
//         <div className="hidden md:flex w-1/2 bg-slate-800 flex-col items-center justify-center p-8">
//           <div className="text-2xl font-bold mb-2">🎲 IQ Cage</div>
//           <p className="text-gray-400">Play smart. Win big.</p>
//         </div>

//         {/* Right Side */}
//         <div className="flex-1 p-8 relative">
//           <button onClick={onClose} className="absolute top-4 right-4">
//             <XMarkIcon className="h-6 w-6 text-white" />
//           </button>

//           {mode === "login" ? (
//             <LoginForm
//               onClose={onClose}
//               onSwitchToRegister={() => setMode("register")}
//             />
//           ) : (
//             <RegisterForm
//               onClose={onClose}
//               onSwitchToLogin={() => setMode("login")}
//               affiliateId={affiliateId} // ✅ Pass it here!
//             />
//           )}
//         </div>
//       </div>
//     </div>
//   );
// };

// export default AuthModal;

import { useState, useEffect } from "react";
import LoginForm from "./LoginForm";
import RegisterForm from "./RegisterForm";
import { XMarkIcon } from "@heroicons/react/24/outline";
import { useLocation, useNavigate } from "react-router-dom";

// Helper to extract ?lid=... from the URL
function useAffiliateId() {
  const { search } = useLocation();
  const params = new URLSearchParams(search);
  return params.get("lid") || "";
}

const AuthModal = ({ isOpen, onClose, initialMode = "login" }) => {
  const [mode, setMode] = useState(initialMode); // 'login' or 'register'
  const affiliateId = useAffiliateId();
  const navigate = useNavigate();

  useEffect(() => {
    if (isOpen) setMode(initialMode);
  }, [isOpen, initialMode]);

  if (!isOpen) return null;

  // This handler is passed down to LoginForm/RegisterForm as "onClose".
  // They should call it after a SUCCESSFUL auth.
  // It will redirect back to the saved offer URL if present; otherwise fallback to the parent onClose.
  const handleAuthSuccessClose = () => {
    const redirectTo = sessionStorage.getItem("postLoginRedirect");
    if (redirectTo) {
      sessionStorage.removeItem("postLoginRedirect");
      navigate(redirectTo, { replace: true });
      // Do NOT call parent onClose here — navigating replaces the modal route (/login or /register)
      return;
    }
    // No post-login target saved; use the parent close behavior (your app currently navigates home there)
    onClose?.();
  };

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-60">
      <div className="bg-slate-900 text-white w-full max-w-4xl mx-4 md:mx-auto rounded-2xl overflow-hidden shadow-2xl flex">
        {/* Left Side */}
        <div className="hidden md:flex w-1/2 bg-slate-800 flex-col items-center justify-center p-8">
          <div className="text-2xl font-bold mb-2">🎲 IQ Cage</div>
          <p className="text-gray-400">Play smart. Win big.</p>
        </div>

        {/* Right Side */}
        <div className="flex-1 p-8 relative">
          {/* The X button should behave like a plain close (no redirect) */}
          {/* <button onClick={onClose} className="absolute top-4 right-4"> */}
          <button
            onClick={() => {
              const redirectTo = sessionStorage.getItem("postLoginRedirect");
              if (redirectTo) {
                sessionStorage.removeItem("postLoginRedirect");
                // This will also unmount the modal because the route changes
                navigate(redirectTo, { replace: true });
              } else {
                onClose?.();
              }
            }}
            className="absolute top-4 right-4"
          >
            <XMarkIcon className="h-6 w-6 text-white" />
          </button>

          {mode === "login" ? (
            <LoginForm
              // IMPORTANT: pass our redirect-aware closer
              onClose={handleAuthSuccessClose}
              onSwitchToRegister={() => setMode("register")}
            />
          ) : (
            <RegisterForm
              // IMPORTANT: pass our redirect-aware closer
              onClose={handleAuthSuccessClose}
              onSwitchToLogin={() => setMode("login")}
              affiliateId={affiliateId}
            />
          )}
        </div>
      </div>
    </div>
  );
};

export default AuthModal;
